/**
 * @typedef {Object} ApiError
 * @property {string} code
 * @property {string} message
 * @property {number} status
 * @property {unknown} [details]
 */

export class ApiClientError extends Error {
  constructor({ code, message, status, details }) {
    super(message);
    this.name = 'ApiClientError';
    this.code = code;
    this.status = status;
    this.details = details;
  }
}

export function isApiError(err) {
  return !!err && typeof err === 'object' && typeof err.code === 'string';
}

/**
 * Stable-code-based branching helper.
 * @param {unknown} err
 * @param  {...string} codes
 */
export function isApiErrorCode(err, ...codes) {
  return isApiError(err) && codes.includes(err.code);
}
